import styled from 'styled-components';
import { getSpace, getGridSpans, getTextType } from '../../../stylesheets/tools';

const StyledExhibitionPage = styled.div`
  background: #000;
  color: #fff;

  h1,
  h2,
  h3,
  h4,
  p,
  span {
    color: #fff;
  }

  .exhibition__outro {
    position: relative;
    background: #000;
    padding: ${getSpace('xxxl')} 0;
    text-align: center;
  }

  .exhibition__outro-wrapper {
    position: relative;
    ${getGridSpans('width', { s: 12, m: 8, l: 6 })};
    margin: 0 auto;
  }

  .exhibition__outro-link {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: ${getSpace('l')};

    svg {
      margin-right: ${getSpace('xxs')};
      fill: #fff;
    }
  }

  /* exhibition theme related overwrites */
  & > section {
    z-index: 2;
  }

  .breadcrumb__wrapper li,
  .breadcrumb__back:before {
    border-color: #fff;
  }

  .stage__introduction,
  .stage__link svg,
  .breadcrumb__link,
  .breadcrumb__back button {
    color: #fff;
  }

  .stage__wrapper h1 {
    ${getTextType('big')};
  }
`;

export default StyledExhibitionPage;
